module.exports = __webpack_public_path__ + "static/media/fill-drip.b742df9d.svg";